import { graphql, Script } from 'gatsby';

import { PropsWithChildren } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

import { Header } from '../Header';
import { Footer } from '../Footer';

type LayoutProps = {
  data: Queries.LayoutFragment;
};

export function Layout({ children, data }: PropsWithChildren<LayoutProps>) {
  return (
    <ParallaxProvider>
      <Header data={data} />
      <main>{children}</main>
      <Footer data={data} />

      <Script id={'gtag_report_conversion'}>
        {`function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-16576987516/XGKtCJbdsb8ZEPyCw-A9',
      'event_callback': callback
  });
  return false;
}`}
      </Script>
    </ParallaxProvider>
  );
}

export const query = graphql`
  fragment Layout on Query {
    ...Footer
    ...Header

    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
